import { render, staticRenderFns } from "./ListTransition.vue?vue&type=template&id=175980a9&scoped=true"
import script from "./ListTransition.vue?vue&type=script&lang=ts"
export * from "./ListTransition.vue?vue&type=script&lang=ts"
import style0 from "./ListTransition.vue?vue&type=style&index=0&id=175980a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175980a9",
  null
  
)

export default component.exports